import React, { useState, useRef, useEffect } from 'react';

const AudioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  // Handle audio events to keep state in sync
  useEffect(() => {
    const audio = audioRef.current;

    const handleEnded = () => {
      setIsPlaying(false);
    };

    const handlePlay = () => {
      setIsPlaying(true);
    };

    const handlePause = () => {
      setIsPlaying(false);
    };

    if (audio) {
      audio.addEventListener('ended', handleEnded);
      audio.addEventListener('play', handlePlay);
      audio.addEventListener('pause', handlePause);
    }

    // Cleanup
    return () => {
      if (audio) {
        audio.removeEventListener('ended', handleEnded);
        audio.removeEventListener('play', handlePlay);
        audio.removeEventListener('pause', handlePause);
      }
    };
  }, []);

  // Toggle play/pause
  const toggleMusic = (e) => {
    e?.stopPropagation();
    e?.preventDefault();

    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      // Set volume
      audioRef.current.volume = 0.5;

      // Reset to start if audio has ended
      if (audioRef.current.ended) {
        audioRef.current.currentTime = 0;
      }

      audioRef.current.play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch(err => {
          console.log('Play failed:', err);
          setIsPlaying(false);
        });
    }
  };

  return (
    <>
      {/* Hidden audio element */}
      <audio ref={audioRef} preload="auto">
        <source src="/song.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      {/* Music Player Button */}
      <button
        data-music-button
        onClick={toggleMusic}
        className={`relative p-2 rounded-full transition-all duration-300 ${
          isPlaying
            ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white animate-pulse'
            : 'bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-gray-600'
        }`}
        title={isPlaying ? 'Pause music' : 'Play music'}
        aria-label={isPlaying ? 'Pause background music' : 'Play background music'}
      >
        {isPlaying ? (
          // Pause icon
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
          </svg>
        ) : (
          // Play icon
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
            <path d="M8 5v14l11-7z" />
          </svg>
        )}
      </button>
    </>
  );
};

export default AudioPlayer;
